import(/* webpackMode: "eager" */ "/tmp/build_bf5af132/web/src/app/global-error.tsx")